import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { countries } from '../../constants/labels';
import { getStrictMenu } from '../../actions/questioner';

const StrictMenu = (props) => {
  const { getStrictMenu, strictMenuData } = props;

  useEffect(() => {
    getStrictMenu();
  }, []);

  return (
    <div className="wrapper">
      <h1>
        Questioner
      </h1>
      <table className="table">
        <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Countries</th>
          <th>Created at</th>
        </tr>
        </thead>
        <tbody>
        {strictMenuData?.map((remindMeItem) => (
          <tr key={remindMeItem.id}>
            <td>
              {remindMeItem.name}
            </td>
            <td>{remindMeItem.email}</td>
            <td>{countries[remindMeItem.country]}</td>
            <td>{moment(remindMeItem.created_at).format('DD/MM/yyyy HH:mm')}</td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (store) => ({
  strictMenuData: store.questioner.strictMenuData,
});

const mapDispatchToProps = {
  getStrictMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(StrictMenu);